import React, { FormEvent, useState } from 'react';
import { useDispatch } from 'react-redux';
import AuthContainer from './AuthContainer';
import { login } from '../../redux/actions/auth';
import { Button, Input, InputOnChangeData } from 'semantic-ui-react';

const Login = () => {
  const [username, setUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const dispatch = useDispatch();

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    dispatch(login(username, password));
  };

  return (
    <AuthContainer>
      <form onSubmit={handleSubmit} className="login-form">
        <label htmlFor="username">Email</label>
        <Input
          id="username"
          placeholder="username"
          type="email"
          onChange={(e, val: InputOnChangeData) => setUsername(val.value)}
        />
        <label htmlFor="password">Password</label>
        <Input
          id="password"
          placeholder="password"
          type="password"
          onChange={(e, val: InputOnChangeData) => setPassword(val.value)}
        />
        <Button type="submit">Login</Button>
      </form>
    </AuthContainer>
  );
};

export default Login;
